export const addFavorite = '/favorite/addToFavorite';
export const getFavorite = '/favorite/myFavoriteList';
export const deleteFavorite = '/favorite/deleteFavorite';